var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CopyAll from "@mui/icons-material/CopyAll";
import DocumentScannerOutlined from "@mui/icons-material/DocumentScannerOutlined";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import QrCode from "@mui/icons-material/QrCode";
import { Box, Button, Tooltip } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from "uuid";
import { useWebgate } from "@xvia/webgate-connect";
import { consultarAnistia, generateBoleto, getBoleto, } from "../../apis/api";
import { calcDataVencimento, formatCurrency, formatDate, formatForPayload, paddingCpfCnpj, somaDeValores, } from "../../util/utilitarios";
import { DialogAnteciparParcelas } from "../Dialog";
import { DialogPix } from "../DialogPix";
import { DialogBoleto } from "../DialogBoleto";
import { DialogQuitarParcelas } from "../DialogQuitarParcelamento";
import Loader from "../Loading";
import { StyledTableCell } from "./styles";
import copy from "copy-to-clipboard";
import { DialoCancelarAnistia } from "../DialogCancelarAnistia";
var cellStyle = {
    padding: 0.5,
    fontSize: 14,
};
var iconsStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};
var cellStyleIpvaIsento = {
    padding: 0.5,
    fontSize: 14,
    fontWeight: "bold",
    color: "#00ad00",
};
var buttonStyle = {
    backgroundColor: "outlined transparent",
    color: "#212121",
    fontSize: 12,
};
var buttonStyleParcelamento = {
    backgroundColor: "#034EA2",
    color: "#ffffff",
    fontSize: 12,
    padding: 1,
    marginLeft: 2,
    marginTop: 0.5,
    marginBottom: 0.5,
    fontWeight: "bold",
};
var desconto = false;
var renavam;
var dataUser;
function CustomTableHeader(props) {
    var item = props.data;
    return (_jsxs(_Fragment, { children: [_jsx(TableHead, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ sx: {
                            backgroundColor: "#EEEEEE",
                            fontWeight: "bold",
                            padding: 0.5,
                            fontSize: 12,
                        }, colSpan: desconto ? 14 : 13, align: "center" }, { children: props.text })) }, uuidv4()) }), _jsx(TableBody, { children: item === null || item === void 0 ? void 0 : item.map(function (item, index) { return (_jsxs(TableRow, __assign({ sx: {
                        "&:last-child td, &:last-child th": {
                            border: 0,
                        },
                    } }, { children: [_jsx(TableCell, __assign({ sx: cellStyle, component: "th", scope: "row", align: "center" }, { children: Number(item === null || item === void 0 ? void 0 : item.numeroDocumento) || " - " })), _jsx(TableCell, __assign({ sx: cellStyle, component: "th", scope: "row", align: "center" }, { children: (item === null || item === void 0 ? void 0 : item.descricaoCota) || (item === null || item === void 0 ? void 0 : item.numeroParcela) })), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: formatDate(item === null || item === void 0 ? void 0 : item.periodoReferencia) })), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: item === null || item === void 0 ? void 0 : item.dataVencimento })), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: formatCurrency(item === null || item === void 0 ? void 0 : item.valorPrincipal) })), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: formatCurrency(item === null || item === void 0 ? void 0 : item.multa) })), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: formatCurrency(item === null || item === void 0 ? void 0 : item.juros) })), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: formatCurrency(item === null || item === void 0 ? void 0 : item.atualizacao) || "R$0,00" })), desconto && (_jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: formatCurrency(item.desconto) || "R$ 0,00" }))), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: item.isencaoLei7995 ? (_jsxs("div", __assign({ style: {
                                    whiteSpace: "nowrap",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                } }, { children: [_jsx("span", __assign({ style: { marginRight: 4 } }, { children: item.descricaoEstado === "IPVA ISENTO/IMUNE"
                                            ? "R$0,00"
                                            : somaDeValores(item === null || item === void 0 ? void 0 : item.total, item === null || item === void 0 ? void 0 : item.multa, item === null || item === void 0 ? void 0 : item.juros, (item === null || item === void 0 ? void 0 : item.desconto) || 0) })), _jsx(Tooltip, __assign({ title: item.isencaoLei7995 }, { children: _jsx(InfoOutlinedIcon, { sx: { color: "#6EC5AE", fontSize: 18 } }) }))] }))) : (_jsx("span", __assign({ style: { marginRight: 4 } }, { children: item.descricaoEstado === "IPVA ISENTO/IMUNE"
                                    ? "R$0,00"
                                    : somaDeValores(item === null || item === void 0 ? void 0 : item.total, item === null || item === void 0 ? void 0 : item.multa, item === null || item === void 0 ? void 0 : item.juros, (item === null || item === void 0 ? void 0 : item.desconto) || 0) }))) })), item.descricaoEstado === "IPVA ISENTO/IMUNE" ? (_jsx(TableCell, __assign({ sx: cellStyleIpvaIsento, colSpan: 4, align: "center" }, { children: "IPVA ISENTO/IMUNE" }))) : (_jsxs(_Fragment, { children: [_jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: _jsx(Button, __assign({ sx: buttonStyle, onClick: function () { return props.hadleCopyBoleto(item); } }, { children: _jsxs("div", __assign({ style: iconsStyle }, { children: [_jsx(CopyAll, { sx: { color: "gray" } }), _jsx("span", __assign({ style: { marginLeft: "5px" } }, { children: "Copiar" }))] })) })) })), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: _jsx(Button, __assign({ sx: buttonStyle, onClick: function () { return props.handleQrCodePix(item); } }, { children: _jsx("div", __assign({ style: iconsStyle }, { children: _jsx(QrCode, { sx: { color: "gray" } }) })) })) })), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: _jsx(Button, __assign({ sx: buttonStyle, onClick: function () { return props.hadleGenerateBoleto(item); } }, { children: _jsx("div", __assign({ style: iconsStyle }, { children: _jsx(DocumentScannerOutlined, { sx: { color: "gray" } }) })) })) })), _jsx(TableCell, __assign({ sx: cellStyle, align: "center" }, { children: _jsx(Button, __assign({ sx: buttonStyle, onClick: function () { return null; } }, { children: _jsx("div", __assign({ style: iconsStyle }, { children: _jsx(CreditCardIcon, { sx: { color: "gray" } }) })) })) }))] }))] }), index)); }) })] }));
}
function TableListDebitos(_a) {
    var data = _a.data;
    var accessToken = useWebgate().accessToken;
    var _b = useState([]), ipva = _b[0], setIpva = _b[1];
    var _c = useState([]), honorarios = _c[0], setHonorarios = _c[1];
    var _d = useState([]), dividaAtiva = _d[0], setDividaAtiva = _d[1];
    var _e = useState([]), parcelamentoIpva = _e[0], setParcelamentoIpva = _e[1];
    var _f = useState(false), existDesconto = _f[0], setExistDesconto = _f[1];
    var _g = useState(false), existIsencao = _g[0], setExisteInsencao = _g[1];
    var _h = useState(""), mensagemIsencao = _h[0], setMensagemIsencao = _h[1];
    var _j = useState(false), open = _j[0], setOpen = _j[1];
    var _k = useState(false), dialogOpen = _k[0], setDialogOpen = _k[1];
    var _l = useState(false), pixDialogOpen = _l[0], setPixDialogOpen = _l[1];
    var _m = useState(false), boletoDialogOpen = _m[0], setBoletoDialogOpen = _m[1];
    var _o = useState(false), quitarParcelamentoDialogOpen = _o[0], setQuitarParcelamentoDialogOpen = _o[1];
    var _p = useState(false), cancelarAnistia = _p[0], setCancelarAnistia = _p[1];
    var _q = useState(), dadosPix = _q[0], setDadosPix = _q[1];
    var _r = useState(), dadosBoleto = _r[0], setDadosBoleto = _r[1];
    var _s = useState(), debitoBoleto = _s[0], setDebitoBoleto = _s[1];
    var _t = useState({}), debitosAgrupados = _t[0], setDebitosAgrupados = _t[1];
    var _u = useState([]), numerosDocumentoDiferentes = _u[0], setNumerosDocumentoDiferentes = _u[1];
    var _v = useState([]), selectedDebitos = _v[0], setSelectedDebitos = _v[1];
    var _w = useState(), dadoAnistiaSelecionado = _w[0], setDadoAnistiaSelecionad = _w[1];
    var listParcelamento = ["11", "12", "18"];
    var handleClose = function () {
        setOpen(false);
    };
    var handleOpen = function () {
        setOpen(true);
    };
    function buscaAnistia(anistiaSelecionada) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, consultarAnistia(Number(anistiaSelecionada.data[0].numeroDocumento))];
                    case 1:
                        response = _a.sent();
                        if (response.data.numeroAnistia === undefined) {
                            toast.warn("Anistia não encontrada");
                            setCancelarAnistia(false);
                            return [2 /*return*/];
                        }
                        setDadoAnistiaSelecionad(response);
                        setCancelarAnistia(true);
                        return [2 /*return*/];
                }
            });
        });
    }
    function BotaoPagarParcelas(props) {
        var hasAnistia = props.data.some(function (item) { return item.descricaoTipoConta === "ANISTIA"; });
        return (_jsx(_Fragment, { children: _jsx(TableHead, { children: _jsx(TableRow, { children: _jsxs(TableCell, __assign({ sx: {
                            backgroundColor: "#EEEEEE",
                            fontWeight: "bold",
                            padding: 0.5,
                            fontSize: 12,
                        }, colSpan: desconto ? 14 : 13, align: "right" }, { children: [_jsx(Button, __assign({ onClick: function () {
                                    setSelectedDebitos(props.data);
                                    setDialogOpen(true);
                                }, sx: buttonStyleParcelamento }, { children: "Antecipar Parcelas" })), _jsx(Button, __assign({ onClick: function () {
                                    setSelectedDebitos(props.data);
                                    setQuitarParcelamentoDialogOpen(true);
                                }, sx: buttonStyleParcelamento }, { children: "Quitar Parcelamento" })), hasAnistia && (_jsx(Button, __assign({ onClick: function () {
                                    setSelectedDebitos(props.data);
                                    buscaAnistia(props);
                                }, sx: buttonStyleParcelamento }, { children: "Cancelar Anistia" })))] })) }, uuidv4()) }) }));
    }
    function searchBoletoNumber(item) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        payload = {
                            codigoReceita: item.codigoReceita,
                            cpfCnpjRenavan: paddingCpfCnpj(dataUser.conteudoSaida.conteudoSaida.proprietario.cpfCnpjRenavan),
                            numeroDocumento: item.numeroDocumento || "0",
                            numeroParcela: item.numeroParcela || "0",
                            periodoReferencia: item.periodoReferencia,
                            renavam: renavam,
                            valorTotal: formatForPayload(item.total),
                            dataVencimento: calcDataVencimento(item.dataVencimento),
                            valorPrincipal: formatForPayload(item.valorPrincipal),
                            juros: formatForPayload(item.juros),
                            multa: formatForPayload(item.multa),
                            isencaoLei7995: (_a = item.isencaoLei7995) === null || _a === void 0 ? void 0 : _a.trim(),
                        };
                        if (!accessToken) {
                            toast.error("Token de autenticação não encontrado");
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, getBoleto(payload, accessToken)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    }
    function hadleCopyBoleto(item) {
        return __awaiter(this, void 0, void 0, function () {
            var result, textToCopy, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        handleOpen();
                        return [4 /*yield*/, searchBoletoNumber(item)];
                    case 1:
                        result = _a.sent();
                        if ((result === null || result === void 0 ? void 0 : result.codigoBarras) === undefined) {
                            toast.error("Erro ao copiar o Codigo de barras! Tente novamente");
                            return [2 /*return*/];
                        }
                        textToCopy = String(result === null || result === void 0 ? void 0 : result.codigoBarras);
                        try {
                            copy(textToCopy);
                            toast.success("Codigo de barras copiado com sucesso!");
                            return [2 /*return*/, result];
                        }
                        catch (err) {
                            console.error("Erro ao copiar o Codigo de barras:", err);
                            toast.error("Erro ao copiar o Codigo de barras!");
                            return [2 /*return*/, undefined];
                        }
                        finally {
                            // document.body.removeChild(elementToFocus);
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        err_1 = _a.sent();
                        toast.error("Erro");
                        return [3 /*break*/, 4];
                    case 3:
                        handleClose();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function redirectCartao(item) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response, codigoBarras, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        handleOpen();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        url = new URL("https://portal.sefaz.pi.gov.br/pagamento-cartao?cod_barras=");
                        return [4 /*yield*/, searchBoletoNumber(item)];
                    case 2:
                        response = _a.sent();
                        if ((response === null || response === void 0 ? void 0 : response.tokenBoleto) === undefined) {
                            toast.error("Erro ao processar");
                            return [2 /*return*/];
                        }
                        codigoBarras = response.codigoBarras;
                        url.searchParams.append("cod_barras", codigoBarras || "");
                        window.open(url, "_blank", "noopener, noreferrer");
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        handleClose();
                        return [3 /*break*/, 5];
                    case 4:
                        handleClose();
                        return [7 /*endfinally*/];
                    case 5:
                        handleClose();
                        return [2 /*return*/];
                }
            });
        });
    }
    function hadleGenerateBoleto(item) {
        return __awaiter(this, void 0, void 0, function () {
            var result, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        handleOpen();
                        return [4 /*yield*/, searchBoletoNumber(item)];
                    case 1:
                        result = _a.sent();
                        if ((result === null || result === void 0 ? void 0 : result.tokenBoleto) === undefined) {
                            toast.error("Erro ao gerar boleto!");
                            return [2 /*return*/];
                        }
                        setDebitoBoleto(item);
                        setDadosBoleto(__assign(__assign({}, result), { dataVencimento: item.dataVencimento, total: item.total }));
                        setBoletoDialogOpen(true);
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _a.sent();
                        toast.error("Erro ao buscar boleto");
                        return [3 /*break*/, 4];
                    case 3:
                        handleClose();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function handleQrCodePix(item) {
        return __awaiter(this, void 0, void 0, function () {
            var response, dadosPix_1, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        handleOpen();
                        return [4 /*yield*/, searchBoletoNumber(item)];
                    case 1:
                        response = _a.sent();
                        if (!response || !response.qrCode) {
                            toast.warning("Pix temporariamente indisponível\n Tente novamente mais tarde");
                            return [2 /*return*/];
                        }
                        dadosPix_1 = {
                            debitos: item,
                            qrCode: response === null || response === void 0 ? void 0 : response.qrCode,
                        };
                        setPixDialogOpen(true);
                        setDadosPix(dadosPix_1);
                        return [3 /*break*/, 4];
                    case 2:
                        err_3 = _a.sent();
                        toast.error("Algo deu errado!");
                        return [3 /*break*/, 4];
                    case 3:
                        handleClose();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        dataUser = data;
        var debitosAgrupados = {};
        var listaComDescricaoTipoContaAnistia = [];
        var dicionarioObjetosPorNumeroDocumento = {};
        data.conteudoSaida.conteudoSaida.debitos.forEach(function (objeto) {
            if (objeto.tipoConta === "12" ||
                objeto.tipoConta === "18" ||
                objeto.tipoConta === "11") {
                listaComDescricaoTipoContaAnistia.push(objeto);
                if (dicionarioObjetosPorNumeroDocumento[objeto.numeroDocumento]) {
                    dicionarioObjetosPorNumeroDocumento[objeto.numeroDocumento].push(objeto);
                }
                else {
                    dicionarioObjetosPorNumeroDocumento[objeto.numeroDocumento] = [
                        objeto,
                    ];
                }
            }
        });
        var listaComNumerosDocumentoDiferentes = Object.values(dicionarioObjetosPorNumeroDocumento).filter(function (objetos) { return objetos.length > 0; });
        setNumerosDocumentoDiferentes(listaComNumerosDocumentoDiferentes);
        data.conteudoSaida.conteudoSaida.debitos.forEach(function (debito) {
            var tipoConta = debito.tipoConta;
            if (!debitosAgrupados[tipoConta]) {
                debitosAgrupados[tipoConta] = [];
            }
            debitosAgrupados[tipoConta].push(debito);
        });
        setDebitosAgrupados(debitosAgrupados);
        var temDesconto = data.conteudoSaida.conteudoSaida.debitos.some(function (debito) { return debito.desconto; });
        desconto = temDesconto;
        setExistDesconto(temDesconto);
        var newIpva = data.conteudoSaida.conteudoSaida.debitos.filter(function (debito) { return debito.tipoConta === "17"; });
        setIpva(newIpva);
        var newHonorarios = data.conteudoSaida.conteudoSaida.debitos.filter(function (debito) { return debito.tipoConta === "27"; });
        setHonorarios(newHonorarios);
        var newDividaAtiva = data.conteudoSaida.conteudoSaida.debitos.filter(function (debito) { return debito.tipoConta === "10"; });
        setDividaAtiva(newDividaAtiva);
        var newParcelamentoIpva = data.conteudoSaida.conteudoSaida.debitos.filter(function (debito) { return debito.tipoConta === "12"; });
        setParcelamentoIpva(newParcelamentoIpva);
        var exitIsencao = data.conteudoSaida.conteudoSaida.debitos.some(function (item) { return item.isencaoLei7995; });
        setExisteInsencao(exitIsencao);
        var objetoComIsencao = data.conteudoSaida.conteudoSaida.debitos.find(function (objeto) { return objeto.isencaoLei7995; });
        var valorIsencao = objetoComIsencao
            ? objetoComIsencao.isencaoLei7995
            : "";
        setMensagemIsencao(valorIsencao);
        renavam = data.conteudoSaida.conteudoSaida.renavam;
    }, [data]);
    return (_jsxs(_Fragment, { children: [dialogOpen && (_jsx(DialogAnteciparParcelas, { handleClose: function () { return setDialogOpen(false); }, debitos: selectedDebitos, dataUser: dataUser, renavam: renavam })), quitarParcelamentoDialogOpen && (_jsx(DialogQuitarParcelas, { handleClose: function () { return setQuitarParcelamentoDialogOpen(false); }, debitos: selectedDebitos, dataUser: dataUser, renavam: renavam })), cancelarAnistia && (_jsx(DialoCancelarAnistia, { handleClose: function () { return setCancelarAnistia(false); }, debitos: selectedDebitos, dadosAnistia: dadoAnistiaSelecionado, dataUser: dataUser, renavam: renavam })), pixDialogOpen && (_jsx(DialogPix, { handleClose: function () { return setPixDialogOpen(false); }, debito: dadosPix, dataUser: dataUser, renavam: renavam })), boletoDialogOpen && (_jsx(DialogBoleto, { handleClose: function () { return setBoletoDialogOpen(false); }, generateBoleto: function (debito, boleto) {
                    return generateBoleto(debito, dataUser, String(boleto === null || boleto === void 0 ? void 0 : boleto.tokenBoleto));
                }, debito: debitoBoleto, boleto: dadosBoleto, dataUser: dataUser, renavam: renavam })), _jsx(ToastContainer, {}), _jsx(Loader, { open: open, sx: { color: "#fff" }, zIndex: 999 }), existIsencao && (_jsxs(Box, __assign({ sx: {
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    marginBottom: 1,
                } }, { children: [_jsx(InfoOutlinedIcon, { sx: { color: "#6EC5AE", marginRight: 1 } }), mensagemIsencao] }))), _jsx(TableContainer, __assign({ component: Paper, sx: {
                    borderRadius: 1,
                    boxShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),0 1px 5px 0 rgba(0, 0, 0, 0.12)",
                } }, { children: _jsxs(Table, __assign({ sx: { minWidth: 650, textAlign: "center" }, "aria-label": "simple table" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(StyledTableCell, { children: "N\u00FAmero do documento" }), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Parcela" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Periodo" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Data de vencimento" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Valor Principal" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Multa" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Juros" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Atualiza\u00E7\u00E3o" })), existDesconto && (_jsx(StyledTableCell, __assign({ align: "center" }, { children: "Desconto" }))), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Valor a Recolher" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "C\u00F3digo de Barras" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Pix" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Boleto" })), _jsx(StyledTableCell, __assign({ align: "center" }, { children: "Cart\u00E3o" }))] }) }), data.conteudoSaida.conteudoSaida.debitos.length > 0 ? (_jsxs(_Fragment, { children: [Object.entries(debitosAgrupados).map(function (_a) {
                                    var tipoConta = _a[0], debitos = _a[1];
                                    return (_jsx(_Fragment, { children: tipoConta !== "18" &&
                                            tipoConta !== "12" &&
                                            tipoConta !== "11" && (_jsx(CustomTableHeader, { text: debitos[0].descricaoTipoConta, data: debitos, hadleCopyBoleto: hadleCopyBoleto, hadleGenerateBoleto: hadleGenerateBoleto, handleQrCodePix: handleQrCodePix, handleCartaoDeCredito: redirectCartao }, tipoConta)) }));
                                }), numerosDocumentoDiferentes.map(function (debitos, index) { return (_jsxs(_Fragment, { children: [_jsx(CustomTableHeader, { text: debitos[0].descricaoTipoConta, data: debitos, hadleCopyBoleto: hadleCopyBoleto, hadleGenerateBoleto: hadleGenerateBoleto, handleQrCodePix: handleQrCodePix, handleCartaoDeCredito: redirectCartao }, index), listParcelamento.includes(debitos[0].tipoConta) && (_jsx(BotaoPagarParcelas, { data: debitos }))] })); })] })) : (_jsx(TableHead, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ sx: {
                                        backgroundColor: "#EEEEEE",
                                        padding: 2,
                                        fontSize: 14,
                                    }, colSpan: desconto ? 14 : 13, align: "center" }, { children: "N\u00E3o h\u00E1 d\u00E9bitos para este ve\u00EDculo" })) }) }))] })) }))] }));
}
export default TableListDebitos;
